<template>
	<pre v-html="$t('terms.legal_indication7')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication7',
};
</script>

<style scoped></style>
